import {defineStore} from "pinia";

export const useRecruitmentCvTechSourcingStore = defineStore('recruitmentCvTechSourcing', {
    state: () => ({
        recruitmentCvTechSourcing: {},
        recruitmentCvTechSourcings: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setRecruitmentCvTechSourcing(recruitmentCvTechSourcing) {
            this.recruitmentCvTechSourcing = recruitmentCvTechSourcing
        },
        setRecruitmentCvTechSourcings(recruitmentCvTechSourcings) {
            this.recruitmentCvTechSourcings = recruitmentCvTechSourcings
        },
        addRecruitmentCvTechSourcing(recruitmentCvTechSourcing) {
            this.recruitmentCvTechSourcings.unshift(recruitmentCvTechSourcing)
        },
        pushRecruitmentCvTechSourcing(recruitmentCvTechSourcing) {
            this.recruitmentCvTechSourcings.push(recruitmentCvTechSourcing)
        },
        updateRecruitmentCvTechSourcing(recruitmentCvTechSourcing) {
            let index = this.recruitmentCvTechSourcings.findIndex(cl => cl.id === recruitmentCvTechSourcing.id)
            this.recruitmentCvTechSourcings.splice(index, 1, recruitmentCvTechSourcing)
        },
        deleteRecruitmentCvTechSourcing(recruitmentCvTechSourcing) {
            let index = this.recruitmentCvTechSourcings.findIndex(cl => cl.id === recruitmentCvTechSourcing.id)
            this.recruitmentCvTechSourcings.splice(index, 1)
        },
    },
});